export const SubmissionErrorCode = {
  banned: 'SUBMISSION_BANNED',
  closed: 'SUBMISSION_CLOSED',
  notClosable: 'SUBMISSION_NOT_CLOSABLE',
  expired: 'SUBMISSION_EXPIRED',
  assignmentClosed: 'ASSIGNMENT_CLOSED',
  alreadySubmitted: 'SUBMISSION_ALREADY_SUBMITTED',
} as const;
